import * as React from 'react';
import { SearchOff } from '@mui/icons-material';
import { TNotFoundDisplay } from './NotFoundDisplay.types';
import './NotFoundDisplay.styled.scss';

export const NotFoundDisplay: TNotFoundDisplay = ({
  title = 'Нічого не знайдено',
  text = 'На жаль, за вашими критеріями пошуку не знайдено жодного товару',
}) => {
  return (
    <div className="not-found-display">
      <SearchOff className="not-found-display__icon" />
      <h3 className="not-found-display__title">{title}</h3>
      <p className="not-found-display__text">{text}</p>
    </div>
  );
};
